import axios from 'axios'
import utils from '../../utils/utils'

let apiURL = utils.decrypt(document.querySelector("html").getAttribute("api_athena_url"));

if (process.env.NODE_ENV === "development") {
  // alert("开发环境");
  apiURL = 'http://api.jm.md.haiweikexin.com'
}

let http = axios.create({
  timeout: 12000,
  baseURL: apiURL,
  headers: {'Content-Type': 'application/json'}
});

export default http;